import { adminInterface } from '../systems/admin-interface'
import { NotAuthorizedPage } from '../ui/NotAuthorizedPage'

export const notAuthorizedAdminPageElement = adminInterface.createNotAuthorizedAdminPage(NotAuthorizedPage)
